/* eslint-disable import/no-extraneous-dependencies */
const defaultAsyncOptions = {
  component: null,
  delay: 200,
};

export default {
  CmsAdminToolbar: () => ({
    ...defaultAsyncOptions,
    component: import("@olc/cms-teresa/src-fe/admin/vue/core/AdminToolbar/App.vue"),
  }),
  HtmlContentConfigForm: () => ({
    ...defaultAsyncOptions,
    component: import("@olc/cms-teresa/src-fe/contrib/vue/HTMLContent/HTMLContentConfigForm.vue"),
  }),
};
